// LanguageSwitcher.js
import React from "react";
import { useLanguage } from "../utils/LanguageContext";

const LanguageSwitcher = () => {
  const { language, handleLanguageChange } = useLanguage();

  const languages = [
    { code: "en", label: "English" },
    { code: "fr", label: "French" },
  ];

  return (
    <div>
      {/* {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
          disabled={language === lang.code}
          type="button"
        >
          {lang.label}
        </button>
      ))} */}

      <select
        value={language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="bg-gray-800 text-white px-2 py-1 rounded-md"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
